module.exports = __webpack_public_path__ + "assets/62781553e6531c8966d24349c216cad8.png";